<template>
    <ui-dropdown :placement="placement" menu-class="w-[28em]" :trigger-class="triggerClass" :arrow="false"
                 @closed="(e) => $emit('closed',e)" @opened="(e) => $emit('opened',e)">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>
        <template #menu="{ close }">
            <div class="p-4 pt-3">
                <div>
                    <div class="text-xs font-medium text-gray-400 mb-2 gap-4 pl-3">Labour Rate Calculator</div>
                    <div class="grid grid-cols-12 m-0 text-sm p-1">
                        <div class="col-span-6 rounded-xl border bg-yellow-50 p-2 m-0 mr-2">
                            <table class="w-full table-fixed">
                                <tbody>
                                <tr>
                                    <td class="text-xs">Daily Rate</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.dailyRate" @input="setDailyRate"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">Hours Per Shift</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.hoursPerShift" @input="setHoursPerShift"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">Hourly Rate</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.hourlyRate" @input="setHourlyRate"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-span-6 rounded-xl border bg-green-50 p-2 m-0 ml-2">
                            <table class="w-full table-fixed">
                                <tbody>
                                <tr>
                                    <td class="text-xs">No. of Operatives</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.noOfOperatives" @input="setOperatives"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">Output per Shift</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.outputPerShift" @input="setOutputPerShift"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">No. of Shifts</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <span v-text="rounded.noOfShifts"
                                                  class="m-0 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-brand focus:border-brand p-0.5 text-center"></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">Minutes per {{ item.uom }}</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.minutesPerUom" @input="setMinutesPerUom"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-xs">Output per Hour</td>
                                    <td class="text-right w-[4rem] pl-1 text-sm font-open-sans tabular-nums font-semibold">
                                        <div class="flex items-center justify-between">
                                            <ui-input v-model="rounded.outputPerHour" @input="setOutputPerHour"
                                                      field="p-0.5 text-center"></ui-input>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 m-0 text-sm mt-2">
                        <div class="col-span-12 rounded-xl border bg-blue-50 p-2 m-1 flex justify-center">
                            <table class="w-full table-fixed">
                                <tbody>
                                <tr>
                                    <td class="text-xs text-right mr-0">Rate per {{ item.uom }}</td>
                                    <td class="text-left">
                                        <div class="flex items-center justify-between ml-2"
                                             :class="readonly?'w-[5rem]':'w-[8rem]'">
                                            <ui-input v-model="rounded.ratePerUom" @input="setRatePerUom"
                                                      field="p-0.5 text-center" class="inline-block w-full"></ui-input>
                                            <button v-if="!readonly"
                                                    class="bg-white border ml-2 px-2 py-1 text-gray-600 rounded-xl hover:bg-gray-50 hover:border-gray-400 text-xs"
                                                    @click="$emit('apply',rounded.ratePerUom); close()">Apply
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import {resolveNumericText} from "../../../../utils";
import * as math from "mathjs";

export default {
    props: {
        original: Object,
        item: Object,
        labour: Object,
        triggerClass: String,
        alignRight: Boolean,
        type: String,
        readonly: false
    },
    data() {
        return {
            resolveNumericText,
            dailyRate: 300,
            hoursPerShift: 7,
            hourlyRate: 300 / 7,
            noOfOperatives: 1,
            outputPerShift: 25,
            minutesPerUom: 60 / (25 / 7),
            outputPerHour: 25 / 7,
            ratePerUom: this.labour.rate,
            rounded: {
                dailyRate: 0,
                hoursPerShift: 0,
                hourlyRate: 0,
                noOfOperatives: 0,
                noOfShifts: 0,
                outputPerShift: 0,
                minutesPerUom: 0,
                outputPerHour: 0,
                ratePerUom: this.labour.rate,
            }
        }
    },
    watch: {
        labour: {
            handler(newValue, oldValue) {
                this.setRatePerUom(this.labour.rate)
            },
            deep: true
        },
    },
    computed: {
        placement() {
            return this.alignRight ? 'bottom-end' : 'bottom-start'
        },
    },
    methods: {
        setRounded() {
            this.rounded.dailyRate = isFinite(this.dailyRate) ? math.round(this.dailyRate, 2) : 0
            this.rounded.hoursPerShift = isFinite(this.hoursPerShift) ? math.round(this.hoursPerShift, 2) : 0
            this.rounded.hourlyRate = isFinite(this.hourlyRate) ? math.round(this.hourlyRate, 2) : 0
            this.rounded.noOfOperatives = isFinite(this.noOfOperatives) ? math.round(this.noOfOperatives, 2) : 0
            this.rounded.outputPerShift = isFinite(this.outputPerShift) ? math.round(this.outputPerShift, 2) : 0
            this.rounded.minutesPerUom = isFinite(this.minutesPerUom) ? math.round(this.minutesPerUom, 2) : 0
            this.rounded.outputPerHour = isFinite(this.outputPerHour) ? math.round(this.outputPerHour, 3) : 0
            this.rounded.ratePerUom = isFinite(this.ratePerUom) ? math.round(this.ratePerUom, 2) : 0
            this.rounded.noOfShifts = this.outputPerShift ? math.round((isFinite(this.item.quantity) ? this.item.quantity : 0) / this.outputPerShift, 2) : 0
            this.rounded.noOfShifts = isFinite(this.rounded.noOfShifts) ? this.rounded.noOfShifts : 0;
        },
        setOperatives(value) {
            this.noOfOperatives = value
            this.outputPerHour = (this.outputPerShift / this.hoursPerShift)
            this.minutesPerUom = 60 / this.outputPerHour
            this.ratePerUom = this.hourlyRate / this.outputPerHour * this.noOfOperatives
            this.setRounded();
        },
        setDailyRate(value) {
            this.dailyRate = value;
            this.hourlyRate = this.dailyRate / this.hoursPerShift
            this.ratePerUom = (this.hourlyRate / this.outputPerHour) * this.noOfOperatives
            this.setRounded();
        },
        setHoursPerShift(value) {
            this.hoursPerShift = value;
            this.hourlyRate = this.dailyRate / this.hoursPerShift
            this.outputPerShift = this.outputPerHour * this.hoursPerShift
            this.ratePerUom = (this.hourlyRate / this.outputPerHour) * this.noOfOperatives
            this.setRounded();
        },
        setHourlyRate(value) {
            this.hourlyRate = value;
            this.dailyRate = this.hoursPerShift * this.hourlyRate
            this.ratePerUom = (this.hourlyRate / this.outputPerHour) * this.noOfOperatives
            this.setRounded()
        },
        setOutputPerHour(value) {
            this.outputPerHour = value;
            this.minutesPerUom = 60 / this.outputPerHour
            this.outputPerShift = this.outputPerHour * this.hoursPerShift
            this.ratePerUom = this.hourlyRate / this.outputPerHour * this.noOfOperatives
            this.setRounded()
        },
        setMinutesPerUom(value) {
            this.minutesPerUom = value;
            this.outputPerHour = 60 / this.minutesPerUom
            this.outputPerShift = this.outputPerHour * this.hoursPerShift
            this.ratePerUom = this.hourlyRate / this.outputPerHour * this.noOfOperatives
            this.setRounded()
        },
        setOutputPerShift(value) {
            this.outputPerShift = value;
            this.outputPerHour = (this.outputPerShift / this.hoursPerShift)
            this.minutesPerUom = 60 / this.outputPerHour
            this.ratePerUom = this.hourlyRate / this.outputPerHour * this.noOfOperatives
            this.setRounded();
        },
        setRatePerUom(value) {
            this.ratePerUom = value;
            this.outputPerHour = (this.hourlyRate / this.ratePerUom) * this.noOfOperatives
            this.minutesPerUom = (60 / this.outputPerHour)
            this.outputPerShift = (this.outputPerHour * this.hoursPerShift)
            this.setRounded();
        },
        scope(dropdownScope) {
            let that = this
            return {
                ...dropdownScope,
            }
        },
        update(close = () => {
        }) {
            this.$emit('updated')
            close()
        },
    },
    mounted() {
        this.setRatePerUom(this.labour.rate)
        this.setRounded()
    }
}
</script>
